import cx from 'classnames';
import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  // removes x-axis padding when set to true to allow for <hr/> spanning entire card
  sectioned?: boolean;
  padding?: string;
  style?: React.CSSProperties;
}

function Card({ children, className, sectioned, padding, style }: CardProps) {
  return (
    <div
      className={cx('bg-base border', 'rounded', padding || (sectioned ? 'py-4' : 'py-4 px-6'), className)}
      style={style}
    >
      {children}
    </div>
  );
}

Card.defaultProps = { className: '', sectioned: false };

export default React.memo(Card);
